import ArrowBtn from 'components/buttons/ArrowBtn'
import useFetchedData from 'hooks/useFetchedData'
import useTranslation from 'hooks/useTranslation'
import { toPhoneString } from 'utils/string'
import Popup from 'components/popups/Popup'
import { announcement } from 'rest/urls'
import Loading from 'components/Loading'

const AnnouncementPopup = ({ placeId }) => {
  const { isLoading, data } = useFetchedData(placeId ? announcement(placeId) : '', '', 'GET')
  const { t } = useTranslation('map')
  return (
    <Popup>
      <div className='popup__title'>
        <div>{t('announcement')}</div>
      </div>
      <div className='popup__infoBlocks'>
        {isLoading
          ? <Loading />
          : <div className='lockItem lockItem--info'>
            <div dangerouslySetInnerHTML={{ __html: data?.announcementHtml }} />
          </div>}

        <ArrowBtn
          enlarged
          disabled={!data}
          text={data?.announcementPhone ? `${t('callUsAt')} ${toPhoneString(data.announcementPhone)}` : t('call')}
          action={() => {
            window.location.href = `tel:${data.announcementPhone}`
          }} />
      </div>
    </Popup>
  )
}

export default AnnouncementPopup